import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedReduxCalendar, setProgramType } from '../../ducks/calendarActions';
import usePreSaveNavigationGuard from '../../hooks/usePreSaveNavigationGuard';

const SubCalendarDiv = styled('div')`
  cursor: pointer;
  margin-bottom: 10px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: #444444;
  background-color: ${({ isSelected }) => (isSelected ? '#f0f0f0' : 'transparent')};
`;

const CollapsedSubCalendar = ({
  subCalendar,
  parentCalendarIndex,
  isSelected,
  isModal,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const guardNavigation = usePreSaveNavigationGuard();
  const parentCalendars = useSelector((state) => state.calendar.data.parentCalendars);

  return (
    <SubCalendarDiv
      onClick={(e) => {
        e.stopPropagation();
        guardNavigation(() => {
          // Set parentCalendarInfo along with the subcalendar selection
          const parentCalendar = parentCalendars[parentCalendarIndex];
          dispatch(setProgramType('calendar'));
          dispatch(setSelectedReduxCalendar({
            ...subCalendar,
            parentCalendarInfo: {
              id: parentCalendar.id,
              name: parentCalendar.name,
            },
          }));
          // Close modal if in modal context
          if (isModal && closeModal) {
            closeModal();
          }
        });
      }}
      data-calendar-id={subCalendar.id}
      isSelected={isSelected}
    >
      {subCalendar.name}
    </SubCalendarDiv>
  );
};

CollapsedSubCalendar.propTypes = {
  subCalendar: PropTypes.instanceOf(Object).isRequired,
  parentCalendarIndex: PropTypes.number.isRequired,
  isSelected: PropTypes.bool,
  isModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

CollapsedSubCalendar.defaultProps = {
  isSelected: false,
  isModal: false,
  closeModal: null,
};

export default CollapsedSubCalendar;
